import { ChangeCompanyData, ChangeCompanyDataAction } from 'src/actions/company/change-data/ChangeCompanyData.actions';
import * as ChangeCompanyDataTypes from 'src/actions/company/change-data/Types';
import CompanyData from 'src/value-objects/CompanyData';

export interface ChangeCompanyDataState {
  company?: CompanyData;
  loading: boolean;
}

const initialState: ChangeCompanyDataState = {
  loading: false
};

export function ChangeCompanyDataReducer(state: ChangeCompanyDataState = initialState,
                                         action: ChangeCompanyDataAction): ChangeCompanyDataState {
  switch (action.type) {
    case ChangeCompanyDataTypes.CHANGE_COMPANY_DATA:
      const company: CompanyData = (action as ChangeCompanyData).payload;
      return {...state, company: company, loading: false};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/company/ChangeCompanyDataReducer.tsx